<template>
  <main>
    <nav class="mdl-navigation">
      <div class="mdl-layout-spacer"></div>
      <theme-switcher :iconTheme="iconTheme" :userLang="userLocale" v-on:themeChanged="setIconTheme($event)"></theme-switcher>
      <profile-link :theme="iconTheme" :userLang="userLocale"></profile-link>
      <language-selector :borderColor="iconTheme === 'dark' ? '#000000' : '#FFFFFF'" :backgroundColor="iconTheme === 'dark' ? '#FFFFFF' : '#000000'" v-on:languageChanged="setLanguage($event)"></language-selector>    
    </nav>
    <section class="mdl-grid header-background">
      <div class="mdl-cell mdl-cell--5-col mdl-cell--3-col-tablet mdl-cell--1-col-phone logo-container">
        <img class="pollscape-logo" src="static/img/icons/ic_pollscape_192x192.png" :alt="$t('message.pollscapeLogoText')">
      </div>
      <div class="mdl-cell mdl-cell--7-col mdl-cell--5-col-tablet mdl-cell--3-col-phone header-text-container">
        <h1>Pollscape</h1>
        <h4>{{ $t('message.pageSubTitle') }}</h4>
        <h4>{{ $t('message.pollscapeDesc') }}</h4>
        <br/>
        <span>
          <a v-if="userLocale === 'hi'" href='https://play.google.com/store/apps/details?id=com.app.pollscape.release&utm_source=web&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img class="fade-in" width="200" height="77" alt='Google Play पर पाएं' src='static/img/google-play-badge-hi.png'/>
          </a>
          <a v-if="userLocale === 'en'" href="https://play.google.com/store/apps/details?id=com.app.pollscape.release&utm_source=web&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
            <img class="fade-in" width="200" height="77" alt="Get it on Google Play" src="static/img/google-play-badge-en.png">
          </a>
        </span>
      </div>
    </section>
    <footer-component :userLang="userLocale"></footer-component>
    <cookie-policy-banner :userLang="userLocale"></cookie-policy-banner>
  </main>
</template>

<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'
  import themeSwitcher from './ThemeSwitcher'
  import profileLink from './ProfileLink'
  import languageSelector from './LanguageSelectorComponent'
  import footerComponent from './Footer'
  import cookiePolicyBanner from './CookiePolicyBanner'

  const messages = {
    en: {
      message: {
        pollscapeLogoText: 'Pollscape logo',
        pageSubTitle: 'Create, share and vote. All of it in real-time!',
        pollscapeDesc: 'Pollscape is a simple polling app that allows you to create polls, share them with your friends and get opinions in real-time'
      }
    },
    hi: {
      message: {
        pollscapeLogoText: 'पोलस्केप लोगो',
        pageSubTitle: 'बनाएं, साझा करें और वोट दें। यह सब वास्तविक समय में!',
        pollscapeDesc: 'Pollscape एक मतदान ऐप है जो आपको चुनाव बनाने, उन्हें अपने दोस्तों के साथ साझा करने और वास्तविक समय में राय प्राप्त करने में सहायता करता है'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    components: {
      themeSwitcher: themeSwitcher,
      profileLink: profileLink,
      languageSelector: languageSelector,
      footerComponent: footerComponent,
      cookiePolicyBanner: cookiePolicyBanner
    },
    data () {
      return {
        userLocale: i18n.locale,
        iconTheme: this.getIconTheme()
      }
    },
    methods: {
      getIconTheme () {
        const currentTheme = typeof (Storage) !== 'undefined' ? localStorage.getItem('theme') ? localStorage.getItem('theme') : 'light' : 'light'
        return currentTheme
          ? currentTheme === 'dark' ? 'light' : 'dark'
          : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'light' : 'dark'
      },
      setIconTheme (theme) {
        this.iconTheme = theme === 'light' ? 'dark' : 'light'
      },
      setLanguage (lang) {
        if (lang === 'en') {
          i18n.locale = 'en'
        } else if (lang === 'hi') {
          i18n.locale = 'hi'
        }
        this.userLocale = i18n.locale
      }
    },
    mounted () {
      document.title = 'Pollscape'
    }
  }
</script>

<style scoped>
  nav {
    overflow: hidden;
    padding: 20px 20px 0px 0px;
  }
  nav>:last-child {
    float: right;
  }

  .header-background {
    padding: 80px 80px 145px 80px;
    background-color: var(--bg-color);
  }
  .logo-container {
    position: relative;
  }
  .pollscape-logo {
    position: absolute;
    top: 40px;
    right: 0;
    float: right;
    width: 145px;
    height: 145px;
  }

  h1,h4 {
    font-weight: 300;
  }

  .header-text-container {
    padding-left: 20px;
  }

  @media only screen and (max-width: 600px) {
    .header-background {
      overflow: hidden;
      padding: 0px 0px 0px 0px;
      background-color: var(--bg-color);
    }

    .pollscape-logo {
      position: relative;
      width: 70px;
      height: 70px;
    }

    .header-text-container {
      padding-left: 0px;
    }
  }

  .fade-in {
  -webkit-animation: fade-in 0.8s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
          animation: fade-in 0.8s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }

  @-webkit-keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

</style>





// WEBPACK FOOTER //
// src/components/Home.vue